import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'list',
    name: 'project.param-assessments.list',
    component: () => import('@/views/control-panel/projects/project/paramAssessments/List.vue'),
  }
]

export default routes
